import { createSafeContext } from 'ui';

type AddEventDateContext = {
  causeId: string;
  eventId?: string;
  dateId?: string;
  isDuplicate?: boolean;
};
const [AddEventDateProvider, useAddEventDate] = createSafeContext<AddEventDateContext>(
  'AddEventDateContext not found'
);

export { AddEventDateProvider, useAddEventDate };
